module.exports = function ($location, scheduleKeyService) {
    return {
        restrict: 'A',
        require: 'olyDynamicContent',
        link(scope, element, attrs, olyDynamicContent) {
            function getScheduleKey() {
                const path = $location.path();

                if (scheduleKeyService.isGlobalScheduleInclusionDefined(path)) {
                    return 'global';
                }

                return null;
            }

            function updateScheduleKey() {
                olyDynamicContent.scheduleKey(getScheduleKey());
            }

            updateScheduleKey();

            scope.$on('$locationChangeSuccess', updateScheduleKey.bind(this));
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-global-schedule.js